import { NcrType, ReferralType } from '../../constants.js'
import isEmpty from '../../utility/isEmpty'

export default {
  /**
   * Determines if customer is enrolled in Referral Rewards
   */
  isReferralRewardsUser (state, getters, rootState, rootGetters) {
    return getReferralInfo(state, getters, rootState, rootGetters).isRewardsUser
  },

  /**
   * Determines if customer is ECR
   */
  isEcrUser (state, getters, rootState, rootGetters) {
    return getReferralInfo(state, getters, rootState, rootGetters).referralType === ReferralType.ecr
  },

  /**
   * Determines if customer is NCR
   */
  isNcrUser (state, getters, rootState, rootGetters) {
    return getReferralInfo(state, getters, rootState, rootGetters).referralType === ReferralType.ncr
  }
}

const getReferralInfo = (state, getters, rootState, rootGetters) => {
  const referralEnabledNCR = !isEmpty(rootState.session.displayNonCustomerReferral) ? rootState.session.displayNonCustomerReferral : false
  const referralEnabledRetail = !isEmpty(rootState.session.displayRetailReferral) ? rootState.session.displayRetailReferral : false

  if (!referralEnabledNCR && !referralEnabledRetail) {
    return { isRewardsUser: false, referralType: ReferralType.none }
  }
  if (rootGetters['customer/isTlxeUser']) {
    return { isRewardsUser: referralEnabledRetail, referralType: ReferralType.ecr } // If retail customer use retail feature flag
  }
  if (!isEmpty(state.ncrCognitoAttribute) ? state.ncrCognitoAttribute === NcrType.customer : false) {
    return { isRewardsUser: referralEnabledNCR, referralType: ReferralType.ncr } // If non-customer use non-customer feature flag
  }
  return { isRewardsUser: false, referralType: ReferralType.none } // If you are not a non-customer or retail customer (nothing linked), disable referral
}
